export default __webpack_public_path__ + "static/media/shape2.bc107d18.svg";